import useToast from 'hooks/useToast'
import { Dispatch, ReactNode, SetStateAction, createContext, useEffect, useState } from 'react'
import type { ToastDetails } from 'components/Banner/BannerTypesUtils.d'

export interface SettingsPageContextProps {
  resetBanner: () => void
  activeBannerId: string | undefined
  setActiveBannerId: Dispatch<SetStateAction<string | undefined>>
  toastDetailsContext: ToastDetails | undefined
  setToastDetailsContext: Dispatch<SetStateAction<ToastDetails | undefined>>
}

const initialState: SettingsPageContextProps = {
  resetBanner: () => {},
  activeBannerId: undefined,
  setActiveBannerId: () => {},
  toastDetailsContext: undefined,
  setToastDetailsContext: () => {},
}

export const SettingsPageContext = createContext<SettingsPageContextProps>(initialState)

interface SettingsPageProviderProps {
  children: ReactNode
}
export function SettingsPageProvider({ children }: SettingsPageProviderProps) {
  const [activeBannerId, setActiveBannerId] = useState<string>()
  const { toastDetails, setToastDetails } = useToast()

  useEffect(() => {
    if (!!activeBannerId) {
      return
    }
    if (!toastDetails) {
      setActiveBannerId(undefined)
      return
    }
  }, [toastDetails])

  const resetBanner = () => {
    setToastDetails(undefined)
  }

  return (
    <SettingsPageContext.Provider
      value={{
        resetBanner,
        activeBannerId,
        setActiveBannerId,
        toastDetailsContext: toastDetails,
        setToastDetailsContext: setToastDetails,
      }}
    >
      {children}
    </SettingsPageContext.Provider>
  )
}

export default SettingsPageContext
